// extracted by mini-css-extract-plugin
export default {"form":"SettingsPortfolio_form__CWs4k"};